import * as session from 'smg/customer-api/session';
import * as models from 'smg/models';
import { RemToPx } from 'smg/rem';
import * as column from 'smg/table/column';
import * as tableLib from 'smg/table/table';
import { DollarFormat } from 'smg/util';
import { Relref } from '../hugo';
import * as payments from '../payments';
import * as search from '../search';

declare interface resp {
    orderPayments: models.OrderPayment[];

    paymentOptionTypes: models.PaymentOptionType[];
}

export default async function main() {
    if (await session.Redirect(undefined, Relref('/login'))) {
        return;
    }

    type r = models.OrderPayment;
    type c = keyof r;
    type d = 'paymentOptionTypes';

    const paymentOptionTypes: Record<string, models.PaymentOptionType> = {};

    class table extends tableLib.Table<r, c, d> {
        RowHeight = RemToPx(parseFloat(getComputedStyle(document.querySelector('.iap-table') as HTMLElement).getPropertyValue('--row-height'))) + 1;

        RowsPerPage = 100;

        GetRowsFromResponse = (d: resp) => {
            tableLib.Table.Map(paymentOptionTypes, d.paymentOptionTypes);

            return d.orderPayments;
        };

        constructor() {
            super('/order-payments', (search.Input as HTMLInputElement), (search.Form as HTMLFormElement));

            this.AddColumns(
                new column.ColumnID(),
                new column.Column({
                    name: 'Payment Method',
                    width: 10,
                    columns: ['paymentOption', 'checkNumber', 'purchaseOrderNumber'],
                    draw: async (td, r) => {
                        if (!r.paymentOption) {
                            return;
                        }

                        td.appendChild(await payments.DrawPaymentOption(r.paymentOption, r));
                    },
                }),
                new column.Column({
                    name: 'Orders',
                    width: 10,
                    columns: 'orderPayments',
                    draw: (td, r) => {
                        if (!r.orderPayments?.length) {
                            return;
                        }

                        td.classList.add('d-flex', 'flex-direction-column');

                        let i = 0;
                        for (const orderPayment of r.orderPayments) {
                            const order = orderPayment.order;
                            if (!(order?.invoiceNumber && orderPayment.total)) {
                                continue;
                            }

                            if (i++) {
                                td.appendChild(document.createTextNode(', '));
                            }

                            const a = document.createElement('a');
                            a.textContent = `#${order.invoiceNumber} - ${DollarFormat(orderPayment.total, false, true)}`;
                            a.href = `/orders/?q=${order.invoiceNumber}`;

                            td.appendChild(a);
                        }
                    },
                }),
                new column.ColumnNumber({
                    name: 'Total',
                    width: '12rem',
                    column: 'total',
                    dollarFormat: true,
                }),
                new column.ColumnDateTime({
                    name: 'Date',
                    width: '7rem',
                    sortDirection: 'desc',
                }),
            );

            this.EnableAutoUpdating(10 * 60 * 1000);
        }
    }

    const t = new table();

    t.Query.SetDefaultQuery('has:total');

    void t.Build();
}